import mutations from "./mutations";
import actions from "./actions";

const state = {
  canPreviewName:
    "目前支持预览文件类型:[ png, jpg, jpeg, gif, pdf] (pdf请单独打开预览)",
  canPreview: ["png", "jpg", "jpeg", "gif", "pdf"],
  imageViewer: {
    Viewers: "",
    docPreviewList: [],
    currentPreviewDocument: [], //当前预览的附件信息
    canPreview: ["png", "jpg", "jpeg", "gif"],
    showImages: false,
    showTable: false, //是否展示table数据
    options: {
      inline: false,
      minWidth: 504,
      minHeight: 504,
      zIndexInline: 2,
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        prev: 4,
        play: {
          show: 0,
          size: "large"
        },
        next: 4,
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4
      }
    }
  },
  pdfViewer: {
    pdfUrl: "",
    showPdf: false,
    currentPreviewDocument: ""
  },
  caseState: {
    pageData: {
      current: 1,
      size: 20,
      pageTotal: 0,
      currentPage: 1
    },
    searchData: {
      current: 1,
      size: 20,
      operatorId: null,
      insureName: "",
      caseNo: "",
      caseState: "",
      caseType: "",
      startDay: "",
      endDay: "",
      entrustTimeStart: "",
      entrustTimeEnd: "",
      type: 1 //0 - 作业方，1 - 委托方
    }
  },
  casePendingState: {
    pageData: {
      current: 1,
      size: 20,
      pageTotal: 0,
      currentPage: 1
    },
    searchData: {
      current: 1,
      size: 20,
      companyId: null,
      insureName: "",
      caseType: ""
    }
  },
  caseHandledState: {
    pageData: {
      current: 1,
      size: 20,
      pageTotal: 0,
      currentPage: 1
    },
    searchData: {
      current: 1,
      size: 20,
      companyId: null,
      insureName: "",
      caseNo: "",
      caseState: "",
      caseType: "",
      startDay: "",
      endDay: "",
      type: 0 //0 - 作业方，1 - 委托方
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
